import React, { FC } from 'react';

import { Card, Carousel, Row } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import Link from 'src/components/Link';
import { IRootReducers } from 'src/reducers';
import { IChallengeResourceRender, IStepsResource } from 'src/shared/models';
import { useWindowSize } from 'utils';

interface OwnProps extends IChallengeResourceRender {
  config: IStepsResource;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ChallengeSteps: FC<Props> = ({ config }) => {
  if (!config) return <React.Fragment />;
  const { arrContent, title, description } = config;
  const carouselRef = React.useRef<any>();

  let isMedium = true;
  let isMediumSmall = true;

  if (typeof window === 'object') {
    const { isMD, isMDSM } = useWindowSize();
    isMedium = isMD;
    isMediumSmall = isMDSM;
  }

  const settingsM = {
    dots: { className: 'imageCarousel__dots' },
    arrows: false,
    bordered: false,
    autoplay: false,
    slidesToShow: isMediumSmall
      ? 1.1
      : arrContent.length <= 2
      ? arrContent.length
      : 2.1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
  };

  const settingsD = {
    dots: { className: 'imageCarousel__dots' },
    arrows: true,
    bordered: false,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
  };

  const settings = isMedium ? settingsM : settingsD;

  const renderMetaLink = (link: string, text_link: string): JSX.Element => {
    if (!link || !text_link) return;
    return (
      <Row className="challengeCard__button" justify="start" align="middle">
        {
          <Link
            href={{
              pathname: link,
            }}>
            <a>
              <span className="challengeCard__link challengeCard__link--active">
                {text_link}
              </span>
              <RightOutlined className="challengeCard__button--arrow" />
            </a>
          </Link>
        }
      </Row>
    );
  };

  const renderMetaDescription = (content: string): JSX.Element => {
    return (
      <span
        className="steps-section__description"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  };

  const renderStepsCards = () => {
    return (
      <div className="steps-carousel">
        <Carousel
          swipeToSlide
          draggable
          ref={(ref) => {
            carouselRef.current = ref;
          }}
          {...settings}>
          {arrContent.map((card, i) => {
            return (
              <Card
                key={`${i}-stepsCard`}
                cover={<img alt={card.title} src={card.imageDesktop} />}>
                <div className="steps-section__content">
                  {card.showNumber && (
                    <div className="steps-section__circle">{i + 1}</div>
                  )}
                  <div>
                    <h3 className="steps-section__title">{card.title}</h3>
                    <p className="steps-section__name">{card.name}</p>
                    {!isMedium && renderMetaDescription(card.content)}
                    {!isMedium && renderMetaLink(card.link, card.textLink)}
                  </div>
                </div>
                {isMedium && renderMetaDescription(card.content)}
                {isMedium && renderMetaLink(card.link, card.textLink)}
              </Card>
            );
          })}
        </Carousel>
      </div>
    );
  };

  return (
    <div className="steps">
      <div className="steps__wrapper">
        <h3 className="steps__title">{title}</h3>
        <p className="steps__description regular-body">{description}</p>
        {renderStepsCards()}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(ChallengeSteps);
